import React, { useContext } from "react";
import SearchResultCard from "./SearchResultCard";
import CourseCard from "../courses/cards/CourseCard";
import { Language } from "../../App";
import { LuGraduationCap, LuBookOpen, LuGraduationCap as LuCapX } from "react-icons/lu";

export default function CoursesResultComp({ data, keyword, loading }) {
  const { lang } = useContext(Language);

  if (!loading && (!data || data.length === 0)) {
    return null;
  }

  return (
    <SearchResultCard
      id="courses"
      icon={<LuGraduationCap />}
      title={lang?.courses || "Courses"}
      count={data?.length}
      link={`/search/courses?keyword=${encodeURIComponent(keyword || "")}`}
      seeAll={!loading && data?.length > 2}
    >
      {loading ? (
        <div className="search-courses-list">
          {[1, 2].map((n) => (
            <div
              key={n}
              className="search-section-card p-3 d-flex flex-column flex-sm-row gap-3"
            >
              <div
                className="search-shimmer-box rounded-3"
                style={{ width: "100%", maxWidth: 160, height: 100, minWidth: 120 }}
              />
              <div className="flex-grow-1 d-flex flex-column justify-content-center">
                <div className="search-shimmer-box mb-2" style={{ height: 16, width: "70%" }} />
                <div className="search-shimmer-box mb-2" style={{ height: 13, width: "45%" }} />
                <div className="search-shimmer-box" style={{ height: 12, width: "30%" }} />
              </div>
            </div>
          ))}
        </div>
      ) : data && data.length > 0 ? (
        <div className="search-courses-list">
          {data.slice(0, 2).map((item, index) => (
            <CourseCard key={item?.id || index} course={item} />
          ))}
        </div>
      ) : (
        <div className="search-empty-state-card">
          <div className="search-empty-icon-wrap">
            <LuCapX />
          </div>
          <h5 className="search-empty-title">{lang?.no_courses_found || "No courses found"}</h5>
          <p className="search-empty-desc">
            {lang?.try_different_keyword || "Try a different keyword or check spelling."}
          </p>
        </div>
      )}
    </SearchResultCard>
  );
}
